"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _AuButton = _interopRequireDefault(require("../elements/AuButton"));
var _AutoIntl = _interopRequireDefault(require("../elements/AutoIntl"));
var _Ford_TMC_ISO_27001_ = _interopRequireDefault(require("../../images/Ford_TMC_ISO_27001_2013.pdf"));
var _SOC = _interopRequireDefault(require("../../images/SOC2.pdf"));
var styles = {
  "container": "security_page-module__container___FJHFA",
  "offset": "security_page-module__offset___zqvk9",
  "banner": "security_page-module__banner___KriLM",
  "lock": "security_page-module__lock___si8KQ",
  "banner_message": "security_page-module__banner_message___LTZfF",
  "hero": "security_page-module__hero___YaYrQ",
  "title": "security_page-module__title___tSBqq",
  "banner_text": "security_page-module__banner_text___BJytp",
  "certificate_container": "security_page-module__certificate_container___r4Wwg",
  "certificate_section": "security_page-module__certificate_section___MA2oZ",
  "aicpa_logo": "security_page-module__aicpa_logo___hUqcL",
  "mossadams_logo": "security_page-module__mossadams_logo___pNWG9",
  "certificate_text": "security_page-module__certificate_text___qWRTZ",
  "text_section": "security_page-module__text_section___aSFHe",
  "certificate_btn": "security_page-module__certificate_btn___dIhOj"
};
class SecurityPage extends _react.default.Component {
  openInNewTab = url => {
    window.open(url, "_blank", "noreferrer");
  };
  render() {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: styles.container
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: styles.offset
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: styles.banner
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: styles.lock
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: styles.banner_message
    }, /*#__PURE__*/_react.default.createElement(_AutoIntl.default, {
      className: styles.title,
      displayId: 'au.security.certifiedSecurity'
    }), /*#__PURE__*/_react.default.createElement(_AutoIntl.default, {
      className: styles.banner_text,
      displayId: 'au.security.commitment'
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: styles.hero
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: styles.certificate_container
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: styles.certificate_section
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: styles.mossadams_logo
    }), /*#__PURE__*/_react.default.createElement(_AuButton.default, {
      size: "small",
      type: "secondary",
      className: styles.certificate_btn,
      displayId: 'au.security.viewCertificate',
      onClick: () => this.openInNewTab(_Ford_TMC_ISO_27001_.default)
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: styles.certificate_section
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: styles.aicpa_logo
    }), /*#__PURE__*/_react.default.createElement(_AuButton.default, {
      size: "small",
      type: "secondary",
      className: styles.certificate_btn,
      displayId: 'au.security.viewCertificate',
      onClick: () => this.openInNewTab(_SOC.default)
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: styles.text_section
    }, /*#__PURE__*/_react.default.createElement(_AutoIntl.default, {
      className: styles.certificate_text,
      displayId: 'au.security.certificate'
    }))));
  }
}
exports.default = SecurityPage;